import * as Long from "long";
import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../../less/IdStyles";
import { selectCoopRole, selectCoopSelectedProjectDifficultyLevel, } from "../../../selectors/selectCoopInfo";
import { selectCoopBuff, selectCoopProjectInfo } from "../../../selectors/selectCoopProjectInfo";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { BuffContextType, BuffTargetType, } from "../../../utils/network/generated/protoTypes";
import { utilBuff } from "../../../utils/utilBuff";
import { ButtonPrimary } from "../../generic/common/ButtonPrimary";
import { Icon } from "../../generic/icon/Icon";
import { IdIcon } from "../../generic/icon/IdIcon";
import { RemainingTimeDisplay } from "../../generic/remaining-time-display/RemainingTimeDisplay";
import { TextLoca } from "../../generic/text/TextLoca";
import { actionModalOpen } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { IdTooltipAnchor, TooltipText } from "../../tooltip";
import { IdCoopRole } from "../info-view/IdCoopRole";
var _CoopProjectStart = function (_a) {
    var coopProject = _a.coopProject, activeCoopProject = _a.activeCoopProject, selectedCoopProjectDifficultyLevel = _a.selectedCoopProjectDifficultyLevel, onStartClick = _a.onStartClick, role = _a.role, currentTimeBuff = _a.currentTimeBuff;
    var selectedCoopProjectDifficulty = coopProject.difficultyLevel.find(function (difficultyLevel) { return difficultyLevel.level === selectedCoopProjectDifficultyLevel; });
    var duration = selectedCoopProjectDifficulty && selectedCoopProjectDifficulty.duration
        ? Long.fromValue(selectedCoopProjectDifficulty.duration)
        : Long.ZERO;
    currentTimeBuff.forEach(function (element) {
        duration = utilBuff.applyTo(duration, element);
    });
    var isProjectAvailable = activeCoopProject != undefined && activeCoopProject.projectId !== undefined;
    var isDisabled = isProjectAvailable || role === IdCoopRole.Member;
    var locaToUseIfDisabled = activeCoopProject === undefined
        ? IdLoca.floatingText_onlyLeaderDeputies
        : IdLoca.floatingText_onlyOneProject;
    var startBtnDOM = isDisabled ? (React.createElement(TooltipText, { id: locaToUseIfDisabled, anchor: IdTooltipAnchor.Bottom },
        React.createElement(ButtonPrimary, { disabled: true },
            React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.start })))) : (React.createElement(ButtonPrimary, { onClick: onStartClick },
        React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.start })));
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "flex flex--guts" },
            React.createElement(Icon, { icon: IdIcon.TimeIcn, styleId: IdStyles.IconSmall }),
            React.createElement(RemainingTimeDisplay, { seconds: duration.low, className: IdStyles.TextBoldAccent })),
        React.createElement("div", { className: "button-ribbon" }, startBtnDOM)));
};
var mapState = function (state) {
    return {
        activeCoopProject: selectCoopProjectInfo(state),
        currentTimeBuff: selectCoopBuff(state, BuffContextType.PROJECT, BuffTargetType.TIME),
        role: selectCoopRole(state),
        selectedCoopProjectDifficultyLevel: selectCoopSelectedProjectDifficultyLevel(state),
    };
};
var mapDispatch = function (dispatch) {
    return {
        onStartClick: function () { return dispatch(actionModalOpen(IdModal.CoopProjectStartConfirm)); },
    };
};
export var CoopProjectStart = connect(mapState, mapDispatch)(_CoopProjectStart);



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/projects/CoopProjectStart.tsx
// module id = 2596
// module chunks = 3